import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("sb_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const mediaUrl = (p) => (p ? `${BACKEND}${p}` : null);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const isUpgradeError = (e) => String(e?.response?.data?.detail || "").startsWith("upgrade_required");
